import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TemaService } from 'src/app/services/tema.services';
import { BrokerService } from 'src/app/services/broker.services';
import { OAuthService } from 'src/app/services/oauth.service';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { translateMetaApiError, translateMetaApiHttpError } from 'src/app/services/meta-api-error-messages';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { SlTpBrokerService } from 'src/app/services/sltp-broker.service';
import { fechaHoyIso } from 'src/app/shared/utils/date-utils';

@Component({
  selector: 'app-editar-orden',
  templateUrl: './editar-orden.component.html',
  styleUrl: './editar-orden.component.scss'
})
export class EditarOrdenComponent implements OnInit, OnDestroy {
  public theme:string;
  public licencia:string;
  public fecha:string;
  public isDark: boolean = false;
  /** Cartera para <app-cotizacion-fuente> (fuente IBKR o MetaTrader según tipoBroker). */
  public wallet: any;
  public secType: string = '';
  public hoy: string = fechaHoyIso();
  public subtema: Subscription;

  public orden = {
      "acctId": '',
      "conid": 0,
      "orderType": "string",
      "outsideRTH": false,
      "price": 0,
      "auxPrice": 0,
      "side": "string",
     // "listingExchange": "string",
      "ticker": "string",
      "tif": "GTC",
      "quantity": 0,
      "deactivated": false
  };
  constructor( public dialogRef: MatDialogRef<EditarOrdenComponent>,
                private _cookieService: CookieService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialog: MatDialog,
                private _sseservice: SseService,
                private _brokerService: BrokerService,
                  private toastr: ToastrService,
private _temaservicio: TemaService, private oauthService: OAuthService,
              private metaApiService: MetaApiService,
              private brokerTimeService: BrokerTimeService,
              private sltp: SlTpBrokerService
              ){

  }
  ngOnDestroy(): void {
    this.subtema.unsubscribe();
  }

  // Decimales según instrumento: MetaAPI usa spec.digits del símbolo si ya está en caché;
  // si no, CFD y MetaAPI (forex/CFD) = 5, resto = 2
  get decimales(): number {
    if (this.wallet?.tipoBroker === 'METAAPI') {
      const accountId = this.data?.metaApiAccountId || this.data?.orden?.acctId;
      const digits = this.metaApiService.digitsEnCache(accountId, this.orden?.ticker);
      if (digits !== null) return digits;
    }
    return this.secType === 'CFD' || this.wallet?.tipoBroker === 'METAAPI' ? 5 : 2;
  }

  get paso(): number {
    return Math.pow(10, -this.decimales);
  }

  ngOnInit(): void {
    console.log("esta es la data que llega ", this.data);
      this.licencia = this._cookieService.get('auth_token');
      this.orden.acctId = this.data.orden.acctId;
      this.orden.conid  = this.data.orden.conid;
      this.orden.orderType  = this.data.orden.orderType;
      this.orden.price  = this.data.orden.price;
      this.orden.auxPrice  = this.data.orden.auxPrice;
      this.orden.side  = this.data.orden.side;
    //  this.orden.listingExchange  = this.data.listingExchange;
      this.orden.ticker  = this.data.orden.ticker;
      this.orden.quantity  = this.data.orden.quantity;
      this.secType = this.data.orden.secType ?? '';
      this.wallet = this.data.wallet ?? { tipoBroker: this.data.tipoBroker, metaApiAccountId: this.data.metaApiAccountId };
      this.fecha= this.data.orden.lastExecutionTime || '';
      // Best-effort: only reformat in the broker's timezone if the raw value
      // turns out to be a parseable timestamp — otherwise leave it exactly as
      // received (today's behavior), since its source format isn't guaranteed.
      if (this.data.tipoBroker === 'METAAPI' && this.data.orden.lastExecutionTime) {
        const parsed = new Date(this.data.orden.lastExecutionTime);
        if (!Number.isNaN(parsed.getTime())) {
          const accountId = this.data.metaApiAccountId || this.data.orden.acctId;
          this.brokerTimeService.getOffsetMinutes(accountId).subscribe(offsetMin => {
            this.fecha = this.brokerTimeService.formatDateTime(parsed, offsetMin);
          });
        }
      }
      console.log("public orden ", this.orden);
      this.subtema = this._temaservicio.valDarkTheme.subscribe({
        next: (data: any) => {
          this.isDark = data;
          this.theme = data ? 'dark-theme' : 'light-theme';
        }
      });
  }

  /** `algoVerificado`: ya se comprobó que MetaTrader tiene Algo Trading activado. */
  editarOrden(algoVerificado = false){
    if (this.data.tipoBroker === 'METAAPI') {
      if (!algoVerificado) {
        // Algo Trading desactivado en MetaTrader: aviso y no se envía la modificación
        this.metaApiService.verificarAlgoTradingParaOperar().subscribe(ok => { if (ok) this.editarOrden(true); });
        return;
      }
      // SL/TP de una posición (tabla de operaciones MT): en MT es un atributo de la posición, no una orden
      const nivel = this.data.nivelPosicion;
      if (nivel) {
        const precio = Number(this.orden.price);
        if (!(precio > 0)) {
          this.toastr.error('Precio no válido');
          return;
        }
        this.sltp.modificarNivelMetaApi(nivel, nivel.lado, precio, Number(nivel.otroPrecio) || 0, this.data.metaApiAccountId);
        this.dialogRef.close();
        return;
      }
      const orderId = this.data.orden.orderId;
      const changes: any = {};
      if (this.orden.orderType === 'LMT') {
        changes.openPrice = this.orden.price;
      } else if (this.orden.orderType === 'STP') {
        changes.openPrice = this.orden.auxPrice;
      } else {
        changes.openPrice = this.orden.price || this.orden.auxPrice;
      }
      this.metaApiService.modifyOrder(this.data.metaApiAccountId, orderId, changes).subscribe({
        next: (res: any) => {
          if (res?.error) {
            const httpErr = res.error;
            const msg = httpErr?.error?.message ?? httpErr?.message ?? JSON.stringify(httpErr);
            const errorClass = httpErr?.error?.error;
            this.toastr.error('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg), 'MetaAPI', { timeOut: 40000, positionClass: 'toast-top-center' });
            return;
          }
          // MetaAPI returns stringCode; only TRADE_RETCODE_DONE (10009) means success
          if (res?.stringCode && res.stringCode !== 'TRADE_RETCODE_DONE') {
            const msg = translateMetaApiError(res.stringCode, res.message);
            this.toastr.error('MetaAPI: ' + msg + ' (' + res.stringCode + ')', 'MetaAPI', { timeOut: 40000, positionClass: 'toast-top-center' });
            return;
          }
          const payload = { orderId, ...changes, ticker: this.orden.ticker, order_status: 'Modified' };
          this._sseservice.apiPostNew('broker/actualizarOrdenPrecio', payload, this.licencia).subscribe({
            next: (data: any) => {
              if (data.status) {
                this._brokerService.updatecargarListas(true);
              }
            }
          });
        },
        error: (err: any) => {
          const msg = err?.error?.message ?? err?.message ?? 'unknown';
          const errorClass = err?.error?.error;
          this.toastr.error('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg), 'MetaAPI', { timeOut: 40000, positionClass: 'toast-top-center' });
        }
      });
      this.dialogRef.close();
      return;
    }
    let urlApi='broker/actualizarOrden';
    this.oauthService.apiPostIbrk('/iserver/account/'+this.orden.acctId+'/order/'+this.data.orden.orderId, this.orden).subscribe({
      next: (data: any)=>{
        if(data.error){
            this.toastr.error(data.error, 'Error', { timeOut: 40000, positionClass: 'toast-top-center' });
        }else {
          this.oauthService.apiGetIbrk('/iserver/account/order/status/'+this.data.orden.orderId).subscribe({
            next: (data: any) => {
              console.log("v1/api/iserver/account/order/status/",data);
              this._sseservice.apiPostNew('broker/actualizarOrdenPrecio', data, this.licencia).subscribe({
                next:(data: any)=>{
                  console.log("broker/actualizarOrdenPrecio",data);
                  if(data.status){
                    this._brokerService.updatecargarListas(true);
                  }
                }
              });
            }
          });
        }

      }
    });
    this.dialogRef.close();

  }

}
